<template>
  <div :class="$style.validation">
    <template v-if="type">
      <p>请输入您的手机联系方式</p>
      <p>获取验证码，进行手机验证</p>
    </template>
    <template v-else>
      <p>请进行绑定手机验证</p>
      <p>绑定手机：{{ this.phone }}</p>
    </template>
  </div>
</template>

<script>
export default {
  name: "phoneVerification",
  props: {
    phone: {
      //手机
      type: String
    },
    type: {
      //类型
      type: Number
    }
  }
};
</script>

<style lang="less" module>
.validation {
  width: 100%;
  p {
    font-size: 0.3rem;
    text-align: left;
    color: #222222;
    padding-left: 0.5rem;
  }
  p:first-child {
    font-size: 0.3rem;
    font-weight: bold;
  }
  p:last-child {
    margin: 0.2rem 0rem 0.4rem 0rem;
  }
}
</style>
